import React, { useReducer } from 'react';
import { useParams } from 'react-router';
import { PagePath } from '../../../../navigation/navigation.enums';
import { PageHeader } from '@keplerco/core';
import * as store from '../freemium-people.cms.store';
import { PageLoaderLayer } from '../../../../components/general/loading-state/loader-layers/page-loader-layer/page-loader-layer';
import { FreemiumPeopleCMSLayout } from '../freemium-people.cms.layout';
export function FreemiumPeopleCMSPage(): JSX.Element {
  const params = useParams();
  const [state] = useReducer(store.reducer, store.initialState);
  return <PageLoaderLayer path={PagePath.freemiumUserManagementPeople}>
    <div className="wrapper stack" style={{ gap: 30 }}>
      <PageHeader breadcrumbs={state.crumbs} title={state.pageTitle} subtitle="Manage access, assign skills and tags, and move team members." />
      <FreemiumPeopleCMSLayout path={PagePath.freemiumUserManagementPeople} slugs={{ companySlug: params.companySlug! }} type="company" />
    </div>
  </PageLoaderLayer>;
}